<template >
    <div class="new-contract-dialog">
        <el-dialog :visible.sync="visible" :title="title" left >
            <div class="msph-dialog-title bg-gray mg-10">
                <p class="msph-dialog-title-p">
                    {{ $t('Common.name') }}：{{ contractInfo.clientName }}
                </p>
                <p class="msph-dialog-title-p">
                    {{ $t('Common.phone') }}：{{ contractInfo.clientPhone }}
                </p>
                <p class="msph-dialog-title-p">
                    {{ $t('Common.card_number') }}：{{ contractInfo.cardNum }}
                </p>
                <template v-if="contract==='personal'">
                    <p class="msph-dialog-title-p">
                        {{ $t('Member.has_zhong') }}：{{ contractInfo.cardName }}
                    </p>
                    <p class="msph-dialog-title-p">
                        {{ $t('Member.start_end_date') }}：{{ contractInfo.validityPeriod }}
                    </p>
                </template>
            </div>
            <el-form
                ref="form"
                :model="contractInfo"
                :rules="rules"
                :status-icon="true"
                label-position="right"
                label-width="120px"
                label-suffix=":">
                <el-form-item
                    :label="$t('Member.saler')"
                >{{contractInfo.contractSalesStaffNickname}}</el-form-item>
                <el-form-item
                    :label="$t('Contract.number')"
                    v-if="contract==='member'"
                >{{contractInfo.contractNum}}</el-form-item>
                <template v-if="['member', 'storeValue', 'upgrade'].includes(contract)">
                    <el-form-item
                        :label="$t('Contract.card_name')"
                    >{{contractInfo.cardName}}</el-form-item>
                    <el-form-item
                        :label="$t('Member.open_card_method')"
                        v-if="contract==='storeValue'"
                    >{{contractInfo.activeCardWay}}</el-form-item>
                    <el-form-item
                        :label="$t('Contract.support_store')"
                    >{{contractInfo.supportStoreNames}}</el-form-item>
                </template>
                <el-form-item
                    :label="$t('Course.coach')"
                    v-if="contract==='personal'"
                >{{contractInfo.coachNickname}}</el-form-item>
                <el-form-item
                    :label="$t('Course.name')"
                    v-if="contract==='personal'"
                >{{contractInfo.lessonName}}</el-form-item>
                <el-form-item
                    :label="$t('Member.price_level')"
                    v-if="contract==='personal'"
                >{{contractInfo.priceLevel}}</el-form-item>
                <el-form-item
                    :label="$t('Member.buy_count')"
                    v-if="contract==='personal'"
                >{{contractInfo.lessonCredit}}</el-form-item>
                <el-form-item
                    :label="$t('Common.cabinet_number')"
                    v-if="contract==='locker'"
                >{{contractInfo.lockerCode}}</el-form-item>
                <el-form-item
                    :label="$t('Week.lease_period2')"
                    v-if="contract==='locker'">{{contractInfo.leaseStr}}</el-form-item>
                <el-form-item
                    :label="['member', 'storeValue', 'upgrade'].includes(contract)
                    ? $t('Member.open_card_store') : $t('Member.sign_store')" >
                    {{contractInfo.storeName}}
                </el-form-item>
                <el-form-item :label="$t('Contract.start_time')" >{{contractInfo.startAt}}</el-form-item>
                <el-form-item
                    :label="$t('Client.Add.referrer')"
                    v-if="['member', 'upgrade'].includes(contract)"
                >{{contractInfo.recommendClientName}}</el-form-item>
                <el-form-item :label="$t('Common.remark')">{{contractInfo.remark}}</el-form-item>
                <div style="border-top:1px solid #ccc; margin: 20px 0px 20px 0px;"></div>
                <el-form-item :label="$t('Sell.Charge.base_amt')">{{contractInfo.baseAmt}}</el-form-item>
                <el-form-item :label="$t('Charge.discounted_price')">{{contractInfo.discountAmt}}</el-form-item>
                <el-form-item :label="$t('Sell.Pay.amounts_payable')">{{contractInfo.payableAmt}}</el-form-item>
                <el-form-item :label="$t('Charge.amount_paid')">{{contractInfo.paidAmt}}</el-form-item>
                <el-form-item :label="$t('Charge.be_paid')">{{contractInfo.oweAmt}}</el-form-item>
                <div style="border-top:1px solid #ccc; margin: 20px 0px 20px 0px;"></div>
                <el-form-item :label="$t('Sell.Pay.title')">
                    <el-select
                        v-model="form.payMethodCode"
                        :placeholder="$t('Sell.Pay.title')"
                        class="col-12">
                        <el-option :label="$t('Sell.Pay.cash')" :value="1"/>
                        <el-option :label="$t('Sell.Pay.swipe')" :value="2"/>
                        <el-option :label="$t('Sell.Pay.bank')" :value="3"/>
                        <el-option :label="$t('Sell.Pay.alipay')" :value="4"/>
                        <el-option :label="$t('Sell.Pay.wechat')" :value="5"/>
                        <el-option :label="$t('Sell.Pay.other')" :value="8"/>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Charge.paid')">
                    <el-input v-model.trim.number="form.money" style="width:150px"/>
                    <span> {{ $t('Reception.Fifth.yuan') }}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer"  style="text-align:center">
                <el-button @click="submit" type="primary">{{ $t('Common.submit') }}</el-button>
            </div>
        </el-dialog>

        <!-- 收取押金 -->
        <deposit-collection ref="collection" />
    </div>
</template>

<script>
import { Dialog } from 'element-ui';
import DepositCollection from '@/components/Dialog/Client/DepositCollection';

export default {
    props: ['contract'],
    components: {
        ElDialog: Dialog,
        DepositCollection,
    },
    data() {
        return {
            contractInfo: {},
            url: '',
            contractNum: '',
            loading: false,
            visible: false,
            title: '',
            form: {
                money: 0,
                payMethodCode: 1,
            },
            rules: {
                money: [
                    {
                        required: true,
                        message: this.$t('Fill.paid'),
                    },
                    {
                        type: 'number',
                        message: this.$t('Fill.paid_type'),
                    },
                ],
                payMethodCode: { required: true, message: this.$t('Sell.Pay.methods'), type: 'number' },
            },
            targetActiveName: null,
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.resetForm();
                this.$emit('close');
            }
        },
    },
    methods: {
        resetForm() {
            this.form = {
                money: 0,
                payMethodCode: 1,
            };
            this.jump(2);
            // setTimeout(() => {
            //     this.$refs.form.resetFields();
            // }, 0)
        },
        open(data) {
            if (data) {
                this.contractNum = data;
                this.getTitle();
                this.fetchData();
                this.visible = true;
            }
        },
        fetchData() {
            this.loading = true;
            API.get(`${this.url}`).then(res => {
                this.contractInfo = res;
                this.form.money = Number(res.oweAmt);
            }).finally(() => {
                this.loading = false;
            });
        },
        getTitle() {
            if (this.contract === 'potential') {
                this.title = this.$t('Member.admission_contract');
                this.url = `contract/mshp/${this.contractNum}`;
                this.targetActiveName = 'member';
            } else if (this.contract === 'member') {
                this.title = this.$t('Stats.Card.member');
                this.url = `contract/mshp/${this.contractNum}`;
                this.targetActiveName = 'member';
            } else if (this.contract === 'storeValue') {
                this.title = this.$t('Stats.Card.value_card');
                this.url = `contract/cz-card/${this.contractNum}`;
                this.targetActiveName = 'cardsCon';
            } else if (this.contract === 'personal') {
                this.title = this.$t('Sell.personal');
                this.url = `contract/coach/${this.contractNum}`;
                this.targetActiveName = 'personal';
            } else if (this.contract === 'locker') {
                this.title = this.$t('Stats.Card.locker');
                this.url = `contract/locker/${this.contractNum}`;
                this.targetActiveName = 'locker';
            } else if (this.contract === 'upgrade') {
                this.title = this.$t('Contract.up');
                this.url = `contract/mshp/${this.contractNum}`;
            }
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.postData();
            });
        },
        async postData() {
            await API.post(`${this.url}/pay`, this.form)
                .then(() => {
                    $ele.$message.success(this.$t('Message.save'));
                    this.$emit('refreshData');
                })
                .finally(() => {
                    this.loading = false;
                })
                .catch(err => {
                    $ele.$message.error(err);
                });
            this.jump(1);
        },
        jump(status) {
            if (this.targetActiveName) {
                this.$router.push({
                    name: 'Sell.Index',
                    query: {
                        activeName: this.targetActiveName,
                        status: status,
                    },
                });
            }
        },
    },
};
</script>

<style lang="scss">
.new-contract-dialog {
    .el-dialog {
        max-height: 800px;
        width: 540px;
    }
    .el-dialog__body {
        max-height: 700px;
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .el-form-item__label {
        font-size: 12px;
    }
    .delete-img {
        top: 0px;
        right: 0px;
        color: gray;
        font-size: 14px;
    }
    .el-dialog__title {
        font-size: 16px;
    }
    .el-dialog__header {
        line-height: 40px;
        background-color: #f2f2f2;
        border-bottom: 1px solid #e6e6e6;
        font-size: 14px;
        color: #333;
        text-align: left;
        padding: 0 45px 0 15px;
    }
    .msph-dialog-title {
        border: 1px solid #e6e6e6;
        padding-left: 10px;
        background: #f7f7f7 !important;
        margin-bottom: 15px;
        padding: 6px 14px;
    }


}
</style>
